module.exports = __webpack_public_path__ + "assets/images/b8cad4bfe819581267f681712838e75e.jpg";